import { render, staticRenderFns } from "./BerlianTerjualSubCabangView.vue?vue&type=template&id=a8ae825c&"
import script from "./BerlianTerjualSubCabangView.vue?vue&type=script&lang=js&"
export * from "./BerlianTerjualSubCabangView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports